import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
   Button,
   useToast,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorModeValue,
   GridItem,
   Grid,
   Text,
   Box,
   Flex,
   useColorMode,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getAccount } from '../../redux/actions/account';
import { useUser, useGlobal } from 'contexts';
import { getDaybook, getPaymentDaybook } from '../../redux/actions/daybook';
import { getWarehouse } from '../../redux/actions/warehouse';
import InputField from 'components/ui/InputField';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import TextareaField from 'components/ui/TextareaField';
import { addSaleInvoice, getLastSaleDaybook } from '../../redux/actions/salesInvoice';
import { addPurchaseInvoice, getLastPurchaseDaybook } from '../../redux/actions/purchaseInvoice';
import { addIssueInventory, getLastIssueDaybook } from '../../redux/actions/issueInventory';
import { getStoreStockForReceive } from '../../redux/actions/reports';
import { findBySerialNo } from 'utils/util';
import moment from 'moment';
import useCalcTaxAmount from '../../hooks/useCalcTaxAmount';
import calculateTaxAmount from 'utils/saleUtility';
import { getBillTerm } from '../../redux/actions/billTerm';
import { getItem } from '../../redux/actions/item';
import { getCompanyById } from '../../redux/actions/company';

const IssuePurchaseEntriesModal = ({ isOpen, onClose, item, subItem, serialNo, onSave, type }) => {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const {
      handleSubmit,
      register,
      reset,
      formState: { errors, isSubmitting },
   } = useForm({
      defaultValues: {
         // Pre-fill form with item data if available
         date: item?.date || '',
         account: item?.accountId || '',
         daybook: item?.daybookId || '',
      },
   });
   const { user } = useUser();
   const { company } = useGlobal();
   const partyNoEqalDocNo = company?.setting?.partynoequaltodocno
      ? company?.setting?.partynoequaltodocno
      : false;
   const toast = useToast();

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   useEffect(() => {
      if (isOpen && user) {
         const fetchData = async () => {
            setIsInitialLoading(true);
            try {
               const data = {
                  companyIds: Number(user?.loginhistory?.companyId),
                  type: 1,
                  fromDate: '2024-01-01',
                  toDate: new Date().toISOString().split('T')[0],
                  serialNo: serialNo,
               };
               // ✅ Await and unwrap
               const response = await dispatch(getStoreStockForReceive(data));

               // if (type === 'receive' || type === 'receiveissue') {
               if (response && response?.onlyReceived !== null) {
                  setFormType('issueforreceive');
                  setRow((prev) => ({
                     ...prev,
                     issueforreceive: {
                        ...prev.issue,
                        notes: response?.onlyReceived[0]?.notes,
                     },
                  }));
               } else if (response && response?.partyIssued !== null) {
                  setFormType('purchaseforreceive');
                  await dispatch(getCompanyById(user?.loginhistory?.companyId));
                  setRow((prev) => ({
                     ...prev,
                     purchaseforreceive: {
                        ...prev.purchase,
                        notes: response?.partyIssued[0]?.notes,
                     },
                  }));
               } else if (response && response?.partyPendingSales !== null) {
                  setFormType('salesforreceive');
                  setRow((prev) => ({
                     ...prev,
                     salesforreceive: {
                        ...prev.sales,
                        notes: response?.partyPendingSales[0]?.notes,
                     },
                  }));
               } else if (response && response?.partyRepairingSold !== null) {
                  reset();
                  onClose();
               }
               // } else if (type === 'purchaseinvoice') {
               if (response && response?.PURCHASE_ONLY !== null) {
                  setFormType('issueforpurchase');
                  setRow((prev) => ({
                     ...prev,
                     issueforpurchase: {
                        ...prev.issueforpurchase,
                        notes: response?.PURCHASE_ONLY[0]?.notes,
                     },
                  }));
               } else if (response && response?.storeIssued !== null) {
                  setFormType('purchaseforpurchase');
                  await dispatch(getCompanyById(user?.loginhistory?.companyId));
                  setRow((prev) => ({
                     ...prev,
                     purchaseforpurchase: {
                        ...prev.purchaseforpurchase,
                        notes: response?.storeIssued[0]?.notes,
                     },
                  }));
               } else if (response && response?.storeRepairingReceived !== null) {
                  reset();
                  onClose();
               }
               // else if (response && response?.partyRepairingSold !== null) {
               //    reset();
               //    onClose();
               // }
               //  else if (response && response?.partyRepairingSold !== null) {
               //    reset();
               //    onClose();
               //  }
               // }
            } catch (error) {
               console.error('Error fetching store stock:', error);
            } finally {
               setIsInitialLoading(false);
            }
         };
         fetchData();
      }
   }, [dispatch, user, isOpen, item?.serialNo]);

   const textColor = useColorModeValue('#9E9E9E', 'white');
   const daybookData = useSelector((state) => state?.daybook?.list || []);
   const warehouse = useSelector((state) => state?.warehouse?.list || []);
   const accountData = useSelector((state) => state?.account?.list || []);
   const storestockdata = useSelector((state) => state?.reports?.storeStockForReceive);
   const PurchaseNotes = storestockdata?.partyPendingSales?.[0]?.notes;
   const ReceiveNotes =
      storestockdata?.partyPendingSales?.[0]?.party_receive_notes ||
      storestockdata?.partyIssued?.[0]?.receive_notes ||
      storestockdata?.onlyReceived?.[0]?.notes;
   const [formType, setFormType] = useState();
   const IssueNotes = storestockdata?.partyPendingSales?.[0]?.issue_notes || storestockdata?.partyIssued?.[0]?.notes;
   const lastIssueDaybook = useSelector((state) => state.issueInventory?.lastIssueDaybook);
   const lastPurchaseDaybook = useSelector((state) => state.purchaseInvoice?.lastPurchaseDaybook);
   const lastSaleDaybook = useSelector((state) => state.sales.lastSaleDaybook);
   const daybookPaymentData = useSelector((state) => state.daybook?.paymentList);
   const itemData = useSelector((state) => state.item?.list);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const warehouseShow = company?.setting?.warehouseWishStock === true && (formType === 'purchaseforreceive' || formType === 'purchaseforpurchase');

   const transactionAtRef = useRef(null);
   const partyNoRef = useRef(null);
   const daybookRef = useRef(null);
   const warehouseRef = useRef(null);
   const accountRef = useRef(null);
   const itemRateRef = useRef(null);
   const paymentRefs = useRef([]);
   const notesRef = useRef(null);
   const updateRef = useRef(null);
   const cancelRef = useRef(null);
   const { data, setData } = useCalcTaxAmount();


   const [isLoading, setIsLoading] = useState(false);
   const [isInitialLoading, setIsInitialLoading] = useState(false);
   const [isFormLoading, setIsFormLoading] = useState(false);
   const daybookType =
      formType === 'issueforreceive' || formType === 'issueforpurchase'
         ? 19
         : formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
            ? 11
            : 5;


   const filteredDaybooks = daybookData.filter(
      (item) => item.type === daybookType
   );

   useEffect(() => {
      if (filteredDaybooks.length === 1 && !row[formType]?.daybookId && isOpen) {
         // handleAccount(formType, 'daybookId', filteredDaybooks[0].id);
         setRow((prev) => ({
            ...prev,
            formType: {
               ...prev[formType],
               daybookId: filteredDaybooks[0].id,
            },
         }));
      }
   }, [filteredDaybooks, daybookType, formType]);

   // const companyData = useSelector((state) => state.company.single);
   // const selectdaybookdata = daybookData.find((daybook) => daybook.id === row[formType]?.daybookId);
   // const herderview =
   //    selectdaybookdata?.warehouseInId === 1
   //       ? true
   //       : selectdaybookdata?.warehouseInId === null
   //          ? companyData?.setting?.warehouseInPurchase === 1
   //             ? true
   //             : false
   //          : false;

   useEffect(() => {
      if (!user) return;
      if (isOpen && user) {
         const fetchData = async () => {
            setIsFormLoading(true);
            try {
               dispatch(getDaybook({ companyId: Number(user?.loginhistory?.companyId), ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }) }));
               dispatch(getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }));

               const fromDate = localStorage.getItem('selectedFy_start_date');
               const toDate = localStorage.getItem('selectedFy_end_date');

               if (formType === 'issueforreceive' || formType === 'issueforpurchase') {
                  dispatch(getAccount({ compId: Number(user?.loginhistory?.companyId), accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','), status: true, ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }) }));
                  const response = await dispatch(getLastIssueDaybook({ companyId: Number(user?.loginhistory?.companyId), fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD') }));
                  setRow((prev) => ({ ...prev, [formType]: { ...prev[formType], daybookId: response?.daybookId, transactionAt: new Date().toISOString().split('T')[0] } }));
               } else if (formType === 'purchaseforreceive' || formType === 'purchaseforpurchase') {
                  const repairingPurchase = daybookData?.find(item => item.name === "REPAIRING PURCHASE");
                  const response = await dispatch(repairingPurchase
                     ? getLastPurchaseDaybook({ companyId: Number(user?.loginhistory?.companyId), fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), daybookId: repairingPurchase.id, isExchangeNotInclude: true })
                     : getLastPurchaseDaybook({ companyId: Number(user?.loginhistory?.companyId), fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), isExchangeNotInclude: true })
                  );
                  await dispatch(getPaymentDaybook({ ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }), isPayment: true, companyId: user?.loginhistory?.companyId }));
                  setRow((prev) => ({ ...prev, [formType]: { ...prev[formType], daybookId: response?.daybookId, transactionAt: new Date().toISOString().split('T')[0] } }));
               } else if (formType === 'salesforreceive' || formType === 'salesforpurchase') {
                  const response = await dispatch(getLastSaleDaybook({ companyId: Number(user?.loginhistory?.companyId), fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD') }));
                  await dispatch(getPaymentDaybook({ ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }), isPayment: true, companyId: user?.loginhistory?.companyId }));
                  setRow((prev) => ({ ...prev, [formType]: { ...prev[formType], daybookId: response?.daybookId, transactionAt: new Date().toISOString().split('T')[0] } }));
               }
               if (formType === 'issueforpurchase') {
                  dispatch(getAccount({ compId: Number(user?.loginhistory?.companyId), accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','), status: true, ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }) }));
                  const response = await dispatch(getLastIssueDaybook({ companyId: Number(user?.loginhistory?.companyId), fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'), toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD') }));
                  setRow((prev) => ({ ...prev, [formType]: { ...prev[formType], daybookId: response?.daybookId, transactionAt: new Date().toISOString().split('T')[0] } }));
               }
            } catch (error) {
               console.error(error);
            } finally {
               setIsFormLoading(false);
            }
         };
         fetchData();
      }
   }, [dispatch, user, formType, formType?.daybookId, isOpen]);
   const [row, setRow] = useState({
      issueforreceive: {
         daybookId: Number(lastIssueDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         accountId: '',
         warehouseId: null,
         notes: item?.notes || '',
      },
      purchaseforreceive: {
         daybookId: Number(lastPurchaseDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         partyNo: '',
         itemRate: '',
         warehouseId: null,
         notes: '',
      },
      salesforreceive: {
         daybookId: Number(lastSaleDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         itemRate: '',
         warehouseId: null,
         notes: '',
      },
      issueforpurchase: {
         daybookId: Number(lastIssueDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         accountId: '',
         warehouseId: null,
         notes: item?.notes || '',
      },
      purchaseforpurchase: {
         daybookId: Number(lastPurchaseDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         partyNo: '',
         itemRate: '',
         warehouseId: null,
         notes: '',
      },
      salesforpurchase: {
         daybookId: Number(lastSaleDaybook?.daybookId) || null,
         transactionAt: new Date().toISOString().split('T')[0],
         itemRate: '',
         warehouseId: null,
         notes: '',
      },
   });

   useEffect(() => {
      if (row[formType]?.daybookId) {
         const selectdaybookdata = daybookData.find((daybook) => daybook.id === row[formType]?.daybookId);
         const warehouseid = warehouseShow
            ? selectdaybookdata?.wareHouseId !== null
               ? selectdaybookdata?.wareHouseId
               : company?.setting?.warehouseId !== null
                  ? company?.setting?.warehouseId
                  : 1
            : null;

         setRow((prev) => ({
            ...prev,
            [formType]: {
               ...prev[formType],
               warehouseId: warehouseid,
            },
         }));
      }
   }, [row[formType]?.daybookId]);

   useEffect(() => {
      if (daybookPaymentData.length > 0 && formType !== 'issueforreceive' && formType !== 'issueforpurchase') {
         const emptyPayments = daybookPaymentData.map((data) => ({
            daybookId: data.id,
            amount: null,
            name: data.name,
         }));
         setPaymentdata(emptyPayments);
      }
   }, [daybookPaymentData, isOpen]);

   const [paymentdata, setPaymentdata] = useState([]);

   const clearFormData = () => {
      setRow({
         issueforreceive: {
            daybookId: '',
            transactionAt: new Date().toISOString().split('T')[0],
            accountId: '',
            warehouseId: '',
            notes: '',
         },
         purchaseforreceive: {
            daybookId: '',
            transactionAt: new Date().toISOString().split('T')[0],
            itemRate: '',
            warehouseId: '',
            notes: '',
         },
         salesforreceive: {
            daybookId: '',
            transactionAt: new Date().toISOString().split('T')[0],
            itemRate: '',
            warehouseId: '',
            notes: '',
         },
         issueforpurchase: {
            daybookId: Number(lastIssueDaybook?.daybookId) || '',
            transactionAt: new Date().toISOString().split('T')[0],
            accountId: '',
            warehouseId: '',
            notes: item?.notes || '',
         },
         purchaseforpurchase: {
            daybookId: Number(lastPurchaseDaybook?.daybookId) || '',
            transactionAt: new Date().toISOString().split('T')[0],
            itemRate: '',
            warehouseId: '',
            notes: '',
         },
         salesforpurchase: {
            daybookId: Number(lastSaleDaybook?.daybookId) || '',
            transactionAt: new Date().toISOString().split('T')[0],
            itemRate: '',
            warehouseId: '',
            notes: '',
         },
      });
      setPaymentdata({});
   };

   const handleAccount = (header, field, value) => {
      // setAccountIds(selectedOptions ? selectedOptions : []);
      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [field]: value,
         },
      }));

      if (field === 'daybookId') {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         if (formType === 'issueforreceive' || formType === 'issueforpurchase') {
            dispatch(
               getLastIssueDaybook({
                  companyId: Number(user?.loginhistory?.companyId),
                  daybookId: value,
                  fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                  toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
               }),
            );
         } else if (formType === 'purchaseforreceive' || formType === 'purchaseforpurchase') {
            dispatch(
               getLastPurchaseDaybook({
                  companyId: Number(user?.loginhistory?.companyId),
                  daybookId: value,
                  fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                  toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
               }),
            );
         } else if (formType === 'salesforreceive' || formType === 'salesforpurchase') {
            dispatch(
               getLastSaleDaybook({
                  companyId: Number(user?.loginhistory?.companyId),
                  daybookId: value,
                  fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                  toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
               }),
            );
         }
      }
   };

   const handlePaymentChange = (field, value) => {
      setPaymentdata((prev) => prev.map((item) => (item.name === field ? { ...item, amount: value } : item)));
   };

   const handleClose = () => {
      setFormType();
      reset();
      clearFormData();
      onClose();
   };
   const handleUpdate = async () => {
      try {
         setIsLoading(true); // Start loading
         const lineitemdatails =
            type === 'receive'
               ? 'receiveLineDetail'
               : type === 'receiveissue'
                  ? 'issueLineDetail'
                  : 'purchaseLineDetail';

         const selectdaybookdata = daybookData.find((daybook) => daybook.id === row[formType]?.daybookId);
         const herderview =
            selectdaybookdata?.warehouseInId !== null
               ? selectdaybookdata?.warehouseInId === 1
               : company?.setting?.warehouseInSale === 1;
         const lineitemview =
            selectdaybookdata?.warehouseInId !== null
               ? selectdaybookdata?.warehouseInId === 2
               : company?.setting?.warehouseInSale === 2;
         const lineDetailview =
            selectdaybookdata?.warehouseInId !== null
               ? selectdaybookdata?.warehouseInId === 3
               : company?.setting?.warehouseInSale === 3;

         let updateData = {
            header: {
               basicAmount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : item?.basicAmount,
               voucherId: item?.voucherId,
               netAmount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : item?.netAmount,
               companyId: item?.companyId,
               additionAmount: item?.additionAmount,
               deductionAmount: item?.deductionAmount,
               dueDays: item?.dueDays,
               transactionAt: moment(row[formType]?.transactionAt).format('YYYY-MM-DD'),
               dueAt: item?.dueAt,
               gstAmount: item?.gstAmount,
               warehouseId: formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
                  ? warehouseShow
                     ? herderview
                        ? row[formType]?.warehouseId !== null
                           ? row[formType]?.warehouseId
                           : 1
                        : null
                     : item?.warehouseId
                  : formType === 'issueforreceive'
                     ? storestockdata?.onlyReceived?.[0].warehouseId
                     : formType === 'salesforreceive'
                        ? storestockdata?.partyPendingSales?.[0].warehouseId
                        : formType === 'issueforpurchase'
                           ? storestockdata?.PURCHASE_ONLY?.[0].warehouseId
                           : item?.warehouseId,
               taxableAmount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : item?.taxableAmount,
               billtoStateId: item?.billtoStateId,
               shiptoStateId: item?.shiptoStateId,
               gstTxnType: item?.gstTxnType,
               gstSubTxnType: item?.gstSubTxnType,
               assesseType: item?.assesseType,
               distance: item?.distance,
               brokerId: item?.brokerId,
               notes: row[formType]?.notes,
               transportId: item?.transportId,
               vehicleId: item?.vehicleId,
               supplierId: item?.supplierId,
               accountId:
                  formType === 'issueforreceive' || formType === 'issueforpurchase'
                     ? row[formType]?.accountId
                     : formType === 'purchaseforreceive'
                        ? storestockdata?.partyIssued[0]?.accountid
                        : formType === 'purchaseforpurchase'
                           ? storestockdata?.storeIssued[0]?.accountid
                           : formType === 'salesforreceive'
                              ? storestockdata?.partyPendingSales[0]?.party_receive_account_id
                              : item.accountId,
               daybookId: row[formType]?.daybookId,
               docno:
                  formType === 'issueforreceive' || formType === 'issueforpurchase'
                     ? lastIssueDaybook?.docno
                        ? Number(lastIssueDaybook?.docno) + 1
                        : 1
                     : formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
                        ? lastPurchaseDaybook.docno
                           ? Number(lastPurchaseDaybook.docno) + 1
                           : 1
                        : formType === 'salesforreceive' || formType === 'salesforpurchase'
                           ? lastSaleDaybook.docno
                              ? Number(lastSaleDaybook.docno) + 1
                              : 1
                           : 1,
            },
         };
         const lineItemsData = findBySerialNo(item.lineitems, serialNo, type);
         const lineItems = lineItemsData?.map((lineItem) => {
            return {
               typeOfSupply: lineItem.typeOfSupply,
               itemId: lineItem.itemId ? Number(lineItem.itemId) : 0,
               isDeleted: false,
               lineNumber: lineItem.lineNumber ? Number(lineItem.lineNumber) : 1,
               itemRate:
                  formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 :
                     row[formType]?.itemRate
                        ? Number(row[formType].itemRate)
                        : 0,
               amount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : lineItem.amount ? Number(lineItem.amount) : 0,
               netAmount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : lineItem.netAmount ? Number(lineItem.netAmount) : 0,
               ratePer: lineItem.ratePer ? Number(lineItem?.ratePer) : 0,
               uomNoForRate: lineItem.uomNoForRate ? Number(lineItem?.uomNoForRate) : 0,
               qUnitId1: lineItem?.qUnitId1,
               qUnitId2: lineItem?.qUnitId2,
               qUnitId3: lineItem?.qUnitId3,
               qty1: lineItem.qty1 ? Number(lineItem.qty1 ?? 0) : 0,
               qty2: lineItem.qty2 ? Number(lineItem.qty2 ?? 0) : 0,
               qty3: lineItem.qty3 ? Number(lineItem.qty3 ?? 0) : 0,
               addLess1Percent: lineItem.addLess1Percent ? Number(lineItem.addLess1Percent) : 0,
               addLess1Amount: lineItem.addLess1Amount ? lineItem.addLess1Amount : 0,
               addLess2Percent: lineItem.addLess2Percent ? Number(lineItem.addLess2Percent) : 0,
               addLess2Amount: lineItem.addLess2Amount ? lineItem.addLess2Amount : 0,
               addLess3Percent: lineItem.addLess3Percent ? Number(lineItem.addLess3Percent) : 0,
               addLess3Amount: lineItem.addLess3Amount ? lineItem.addLess3Amount : 0,
               taxableAmount: formType === 'issueforreceive' || formType === 'issueforpurchase' ? 0 : lineItem.taxableAmount ? lineItem.taxableAmount : 0,
               netGst: lineItem.netGst ? lineItem.netGst : 0,
               gstPercent: lineItem.gst ? lineItem.gst : 0,
               cgst: lineItem.cgst ?? 0,
               sgst: lineItem.sgst ?? 0,
               igst: lineItem.igst ?? 0,
               stock: lineItem[lineitemdatails]?.map((stock) => {
                  return {
                     itemId: stock.itemId,
                     itemName: stock.itemName,
                     isOld: stock.isOld,
                     pcs: stock.quantity1,
                     serialNo: stock.serialNo,
                     serialNo2: stock.serialNo2,
                     warehouseId: formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
                        ? warehouseShow
                           ? herderview
                              ? row[formType]?.warehouseId !== null
                                 ? row[formType]?.warehouseId
                                 : 1
                              : lineitemview
                                 ? row[formType]?.warehouseId !== null
                                    ? row[formType]?.warehouseId
                                    : 1
                                 : lineDetailview
                                    ? row[formType]?.warehouseId !== null
                                       ? row[formType]?.warehouseId
                                       : 1
                                    : null
                           : item?.warehouseId
                        : formType === 'issueforreceive'
                           ? storestockdata?.onlyReceived?.[0].warehouseId
                           : formType === 'salesforreceive'
                              ? storestockdata?.partyPendingSales?.[0].warehouseId
                              : formType === 'issueforpurchase'
                                 ? storestockdata?.PURCHASE_ONLY?.[0].warehouseId
                                 : stock?.warehouseId,
                     ...(formType === 'issueforreceive' && {
                        receiveLineDetailId: storestockdata?.onlyReceived.find((x) => x.serialNo === serialNo)
                           ?.receive_linedetail_id,
                        barcode: storestockdata?.onlyReceived.find((x) => x.serialNo === serialNo)?.barcode,
                     }),
                     ...(formType === 'purchaseforreceive' && {
                        issueLineDetailId: storestockdata?.partyIssued.find((x) => x.serialNo === serialNo)?.id,
                     }),
                     ...(formType === 'salesforreceive' && {
                        pinvLineDetailId: storestockdata?.partyPendingSales.find((x) => x.serialNo === serialNo)?.id,
                        barcode: storestockdata?.partyPendingSales.find((x) => x.serialNo === serialNo)?.barcode,
                     }),
                     ...(formType === 'issueforpurchase' && {
                        pinvLineDetailId: storestockdata?.PURCHASE_ONLY.find((x) => x.serialNo === serialNo)
                           ?.purchase_linedetail_id,
                        barcode: storestockdata?.PURCHASE_ONLY.find((x) => x.serialNo === serialNo)?.barcode,
                     }),
                     ...(formType === 'purchaseforpurchase' && {
                        issueLineDetailId: storestockdata?.storeIssued.find((x) => x.serialNo === serialNo)
                           ?.issue_linedetail_id,
                     }),
                     ...(formType === 'salesforpurchase' && {
                        pinvLineDetailId: storestockdata?.storeRepairingReceived.find((x) => x.serialNo === serialNo)
                           ?.id,
                        barcode: storestockdata?.storeRepairingReceived.find((x) => x.serialNo === serialNo)?.barcode,
                     }),
                  };
               }),
               hsnId: lineItem?.hsnId,
               sacId: lineItem?.sacId,
               warehouseId: formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
                  ? warehouseShow
                     ? herderview
                        ? row[formType]?.warehouseId !== null
                           ? row[formType]?.warehouseId
                           : 1
                        : lineitemview
                           ? row[formType]?.warehouseId !== null
                              ? row[formType]?.warehouseId
                              : 1
                           : null
                     : item?.warehouseId
                  : formType === 'issueforreceive'
                     ? storestockdata?.onlyReceived?.[0].warehouseId
                     : formType === 'salesforreceive'
                        ? storestockdata?.partyPendingSales?.[0].warehouseId
                        : formType === 'issueforpurchase'
                           ? storestockdata?.PURCHASE_ONLY?.[0].warehouseId
                           : item?.warehouseId,
            };
         });

         const payloadData = {
            header: updateData.header,
            lineItem: lineItems,
            saleBillTerms: updateData.receiveBillTerms,
         };

         const payload = calculateTaxAmount(payloadData, {
            company: company,
            user: user,
            itemData: itemData,
            billTermData: billTermData,
            daybookData: daybookData,
         });

         const payments = { paymentdata };

         // if (type === 'receive' || type === 'receiveissue') {
         if (formType === 'issueforreceive') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.accountId !== ''
            ) {
               updateData.lineItem = lineItems;
               updateData.billTerm = [];
               const response = await dispatch(addIssueInventory(updateData));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '' || !row[formType]?.transactionAt) {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '' || !row[formType]?.daybookId) {
                  daybookRef?.current?.focus();
               } else {
                  accountRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         if (formType === 'purchaseforreceive') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.itemRate !== ''
            ) {
               // updateData.lineItem = lineItems;
               // updateData.header = {
               //    ...updateData.header,
               //    partyNo: updateData.header.docno,
               //    partyDate: updateData.header.transactionAt,
               // };
               // updateData.saleBillTerms = [];
               // updateData.payments = paymentdata?.map((item) => ({
               //    daybookId: item.daybookId,
               //    amount: item.amount,
               // }));

               const payments = paymentdata?.map((item) => ({
                  daybookId: item.daybookId,
                  amount: item.amount ? Number(item.amount) : 0,
               }));

               // await setData(updateData);
               // let purData = await data;
               const data = {
                  header: {
                     ...payload?.data?.header,
                     partyNo: partyNoEqalDocNo ? payload?.data?.header?.docno : row[formType]?.partyNo,
                     partyDate: payload?.data?.header?.transactionAt,
                  },
                  lineItem: payload?.data?.lineItem,
                  purchaseBillTerms: payload?.data?.billTerm,
                  payments: payments,
               };
               const response = await await dispatch(addPurchaseInvoice(data));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '') {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '') {
                  daybookRef?.current?.focus();
               } else {
                  itemRateRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         if (formType === 'salesforreceive') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.itemRate !== ''
            ) {
               let exchange = { exchange: [], payments: [] };
               let payments = paymentdata?.map((item) => ({
                  daybookId: item.daybookId,
                  amount: item.amount ? Number(item.amount) : 0,
               }));
               const data = {
                  header: payload?.data?.header,
                  lineItem: payload?.data?.lineItem,
                  saleBillTerms: payload?.data?.billTerm,
                  payments: payments,
                  exchange: exchange,
               };

               const response = await dispatch(addSaleInvoice(data));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '') {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '') {
                  daybookRef?.current?.focus();
               } else {
                  itemRateRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         // } else if (type === 'purchaseinvoice') {
         if (formType === 'issueforpurchase') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.accountId !== ''
            ) {
               updateData.lineItem = lineItems;
               updateData.billTerm = [];
               const response = await dispatch(addIssueInventory(updateData));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '') {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '') {
                  daybookRef?.current?.focus();
               } else {
                  accountRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         if (formType === 'purchaseforpurchase') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.itemRate !== ''
            ) {
               const payments = paymentdata?.map((item) => ({
                  daybookId: item.daybookId,
                  amount: item.amount ? Number(item.amount) : 0,
               }));
               const data = {
                  header: {
                     ...payload?.data?.header,
                     partyNo: payload?.data?.header?.docno,
                     partyDate: payload?.data?.header?.transactionAt,
                  },
                  lineItem: payload?.data?.lineItem,
                  purchaseBillTerms: payload?.data?.billTerm,
                  payments: payments,
               };
               const response = await await dispatch(addPurchaseInvoice(data));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '') {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '') {
                  daybookRef?.current?.focus();
               } else {
                  itemRateRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         if (formType === 'salesforpurchase') {
            if (
               row[formType]?.transactionAt !== '' &&
               row[formType]?.daybookId !== '' &&
               row[formType]?.itemRate !== ''
            ) {
               let exchange = { exchange: [], payments: [] };
               let payments = paymentdata?.map((item) => ({
                  daybookId: item.daybookId,
                  amount: item.amount ? Number(item.amount) : 0,
               }));
               const data = {
                  header: payload?.data?.header,
                  lineItem: payload?.data?.lineItem,
                  saleBillTerms: payload?.data?.billTerm,
                  payments: payments,
                  exchange: exchange,
               };

               const response = await dispatch(addSaleInvoice(data));
               if (response.code === 1) {
                  clearFormData();
                  onClose();
                  onSave();
               }
            } else {
               if (row[formType]?.transactionAt === '') {
                  transactionAtRef?.current?.focus();
               } else if (row[formType]?.daybookId === '') {
                  daybookRef?.current?.focus();
               } else {
                  itemRateRef?.current?.focus();
               }
               toast({
                  title: 'Validation Error',
                  description: 'Please correct the errors.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }
         }
         // }
      } catch (error) {
         console.error('Update failed:', error);
         toast({
            title: 'Error',
            description: 'Something went wrong.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsLoading(false); // End loading no matter what
      }
   };

   const handleKeyDown = (e, nextRef) => {
      if (e.key === 'Enter' && !e.shiftKey) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && !e.shiftKey) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
   };

   const getData = useCallback(async () => {
      if (data?.header?.daybookId) {
         await dispatch(getBillTerm({ daybookId: row[formType]?.daybookId }));
      }
      if (user && user?.loginhistory.companyId) {
         await dispatch(
            getItem({
               companyId: user?.loginhistory.companyId,
               ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }),
               sortBy: 'name',
               sortOrder: 'asc',
            }),
         );
         await dispatch(
            getDaybook({
               companyId: Number(user?.loginhistory?.companyId),
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [data?.header?.daybookId, dispatch, formType, row[formType]?.daybookId, user]);

   useEffect(() => {
      if (isOpen) {
         getData();
         return () => { };
      }
   }, [getData, isOpen]);

   useEffect(() => {
      setTimeout(() => {
         transactionAtRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleClose]);

   return (
      <Modal isOpen={isOpen} onClose={handleClose} size="3xl">
         <ModalOverlay bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
         <ModalContent bg="transparent" borderRadius="2xl" boxShadow="none" maxW="900px">
            {/* Header */}
            <div
               className={`flex items-center justify-between px-6 py-4 rounded-t-2xl ${isDark
                  ? 'bg-gradient-to-r from-slate-800 to-slate-900 border-b-2 border-slate-700'
                  : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-b-2 border-gray-200'
                  }`}>
               <div className="flex items-center gap-3">
                  <div
                     className={`w-10 h-10 rounded-lg flex items-center justify-center ${isDark ? 'bg-blue-500/20' : 'bg-blue-500/10'
                        }`}>
                     <svg
                        className={isDark ? 'text-blue-400' : 'text-blue-600'}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                        <polyline points="10 9 9 9 8 9" />
                     </svg>
                  </div>
                  <h2 className={`text-xl font-semibold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                     {formType === 'issueforreceive' || formType === 'issueforpurchase'
                        ? 'Issue Entry'
                        : formType === 'purchaseforreceive' || formType === 'purchaseforpurchase'
                           ? 'Purchase Entry'
                           : formType === 'salesforreceive' || formType === 'salesforpurchase'
                              ? 'Sales Entry'
                              : ''}
                  </h2>
               </div>
               <button
                  onClick={handleClose}
                  className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${isDark
                     ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                     : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200'
                     }`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                     <path d="M15 5L5 15M5 5l10 10" />
                  </svg>
               </button>
            </div>

            {/* Body */}
            <div className={`px-6 py-6 ${isDark ? 'bg-slate-800' : 'bg-white'}`}>

               {(isInitialLoading || isFormLoading) ? (
                  <div className="flex flex-col items-center justify-center py-16 gap-4">
                     {/* Spinner */}
                     <div className="relative">
                        <div className={`w-14 h-14 rounded-full border-4 animate-spin ${isDark
                           ? 'border-slate-700 border-t-blue-400'
                           : 'border-gray-200 border-t-blue-500'
                           }`} />
                        <div className={`absolute inset-0 w-14 h-14 rounded-full border-4 border-transparent animate-ping opacity-20 ${isDark ? 'border-t-blue-400' : 'border-t-blue-500'
                           }`} />
                     </div>
                     {/* Text */}
                     <div className="text-center">
                        <p className={`text-sm font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                           {isInitialLoading ? 'Loading data...' : 'Preparing form...'}
                        </p>
                        <p className={`text-xs mt-1 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                           Please wait
                        </p>
                     </div>
                  </div>
               ) : (
                  <Grid gap={4} templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }}>
                     {['issueforreceive', 'purchaseforreceive', 'salesforreceive', 'issueforpurchase', 'purchaseforpurchase'].includes(formType) &&
                        (() => {
                           const label =
                              formType === 'issueforreceive'
                                 ? 'Receive'
                                 : formType === 'purchaseforreceive'
                                    ? 'Issue'
                                    : 'Purchase';
                           const formData =
                              formType === 'issueforreceive'
                                 ? storestockdata?.onlyReceived?.[0]
                                 : formType === 'purchaseforreceive'
                                    ? storestockdata?.partyIssued?.[0]
                                    : formType === 'issueforpurchase'
                                       ? storestockdata?.PURCHASE_ONLY?.[0]
                                       : formType === 'purchaseforpurchase'
                                          ? storestockdata?.storeIssued?.[0]
                                          : storestockdata?.partyPendingSales?.[0];

                           return (
                              <>
                                 {/* Receive Section */}
                                 <GridItem colSpan={2}>
                                    <div
                                       className={`rounded-xl p-4 mb-4 border-2 ${isDark
                                          ? 'bg-gradient-to-br from-emerald-900/20 to-teal-900/20 border-emerald-700/50'
                                          : 'bg-gradient-to-br from-emerald-50 to-teal-50 border-emerald-200'
                                          }`}>
                                       <h3
                                          className={`text-sm font-bold mb-3 flex items-center gap-2 ${isDark ? 'text-emerald-300' : 'text-emerald-700'
                                             }`}>
                                          <svg
                                             width="18"
                                             height="18"
                                             viewBox="0 0 24 24"
                                             fill="none"
                                             stroke="currentColor"
                                             strokeWidth="2">
                                             <polyline points="9 11 12 14 22 4" />
                                             <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                                          </svg>
                                          {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Information
                                       </h3>
                                       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                          <div
                                             className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                }`}>
                                             <Text
                                                className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                   }`}>
                                                {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Date
                                             </Text>
                                             <Text
                                                className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {formType === 'salesforreceive'
                                                   ? new Date(formData?.party_receive_date).toLocaleDateString('en-GB')
                                                   : formType === 'purchaseforreceive'
                                                      ? new Date(formData?.receive_Date).toLocaleDateString('en-GB')
                                                      : formType === 'issueforreceive' || formType === 'issueforpurchase'
                                                         ? new Date(formData?.transaction_date).toLocaleDateString('en-GB')
                                                         : formType === 'purchaseforpurchase'
                                                            ? new Date(formData?.purchase_Date).toLocaleDateString('en-GB')
                                                            : ''}
                                             </Text>
                                          </div>
                                          <div
                                             className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                }`}>
                                             <Text
                                                className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                   }`}>
                                                {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Doc No
                                             </Text>
                                             <Text
                                                className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {formType === 'salesforreceive'
                                                   ? formData?.party_receive_doc_no
                                                   : formType === 'purchaseforreceive'
                                                      ? formData?.receive_doc_no
                                                      : formType === 'issueforreceive' || formType === 'issueforpurchase'
                                                         ? formData?.doc_no
                                                         : formType === 'purchaseforpurchase'
                                                            ? formData?.purchase_doc_no
                                                            : ''}
                                             </Text>
                                          </div>
                                          <div
                                             className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                }`}>
                                             <Text
                                                className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                   }`}>
                                                {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Daybook Name
                                             </Text>
                                             <Text
                                                className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {formType === 'salesforreceive'
                                                   ? formData?.receiveDaybookName
                                                   : formType === 'purchaseforreceive'
                                                      ? formData?.receive_daybookName
                                                      : formType === 'purchaseforpurchase'
                                                         ? formData?.purchase_daybookName
                                                         : formData?.daybookName}
                                             </Text>
                                          </div>
                                          <div
                                             className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                }`}>
                                             <Text
                                                className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                   }`}>
                                                {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Account Name
                                             </Text>
                                             <Text
                                                className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {formType === 'salesforreceive'
                                                   ? formData?.receiveAccountName
                                                   : formType === 'purchaseforreceive'
                                                      ? formData?.receive_accountName
                                                      : formType === 'purchaseforpurchase'
                                                         ? formData?.purchase_accountName
                                                         : formData?.accountName}
                                             </Text>
                                          </div>
                                          <div
                                             className={`rounded-lg p-3 border-2 md:col-span-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                }`}>
                                             <Text
                                                className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                   }`}>
                                                {formType === 'issueforpurchase' || formType === 'purchaseforpurchase' ? "Purchase" : "Receive"} Note
                                             </Text>
                                             <Text
                                                className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {(formType === 'issueforpurchase' && formData?.notes) ? formData?.notes : ReceiveNotes || '—'}
                                             </Text>
                                          </div>
                                       </div>
                                    </div>
                                 </GridItem>

                                 {/* Issue Section */}
                                 {['purchaseforreceive', 'salesforreceive', 'purchaseforpurchase'].includes(formType) && (
                                    <GridItem colSpan={2}>
                                       <div
                                          className={`rounded-xl p-4 mb-4 border-2 ${isDark
                                             ? 'bg-gradient-to-br from-amber-900/20 to-orange-900/20 border-amber-700/50'
                                             : 'bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200'
                                             }`}>
                                          <h3
                                             className={`text-sm font-bold mb-3 flex items-center gap-2 ${isDark ? 'text-amber-300' : 'text-amber-700'
                                                }`}>
                                             <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                                <circle cx="8.5" cy="7" r="4" />
                                                <line x1="20" y1="8" x2="20" y2="14" />
                                                <line x1="23" y1="11" x2="17" y2="11" />
                                             </svg>
                                             Issue Information
                                          </h3>
                                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Issue Date
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formType === 'salesforreceive'
                                                      ? formData?.transaction_date
                                                         ? new Date(formData.issue_date).toLocaleDateString('en-GB')
                                                         : ''
                                                      : new Date(formData?.transaction_date).toLocaleDateString('en-GB')}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Issue Doc No
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formType === 'salesforreceive'
                                                      ? formData?.issue_doc_no
                                                         ? formData.issue_doc_no
                                                         : ''
                                                      : formData?.doc_no}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Issue Daybook Name
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formType === 'salesforreceive'
                                                      ? formData?.issueDaybookName
                                                      : formData?.daybookName}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Issue Account Name
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formType === 'salesforreceive'
                                                      ? formData?.issueAccountName
                                                      : formData?.accountName}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 md:col-span-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Issue Note
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formType === 'purchaseforpurchase' && formData?.notes ? formData?.notes : IssueNotes || '—'}
                                                </Text>
                                             </div>
                                          </div>
                                       </div>
                                    </GridItem>
                                 )}

                                 {/* Purchase Section */}
                                 {['salesforreceive'].includes(formType) && (
                                    <GridItem colSpan={2}>
                                       <div
                                          className={`rounded-xl p-4 mb-4 border-2 ${isDark
                                             ? 'bg-gradient-to-br from-violet-900/20 to-purple-900/20 border-violet-700/50'
                                             : 'bg-gradient-to-br from-violet-50 to-purple-50 border-violet-200'
                                             }`}>
                                          <h3
                                             className={`text-sm font-bold mb-3 flex items-center gap-2 ${isDark ? 'text-violet-300' : 'text-violet-700'
                                                }`}>
                                             <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2">
                                                <circle cx="9" cy="21" r="1" />
                                                <circle cx="20" cy="21" r="1" />
                                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                             </svg>
                                             Purchase Information
                                          </h3>
                                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Purchase Date
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formData?.transaction_date
                                                      ? new Date(formData.transaction_date).toLocaleDateString('en-GB')
                                                      : ''}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg flex justify-between p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <div>
                                                   <Text
                                                      className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                         }`}>
                                                      Purchase Doc No
                                                   </Text>
                                                   <Text
                                                      className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                         }`}>
                                                      {formData?.doc_no ? formData.doc_no : ''}
                                                   </Text>
                                                </div>
                                                <div>
                                                   <Text
                                                      className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                         }`}>
                                                      Purchase Party No
                                                   </Text>
                                                   <Text
                                                      className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                         }`}>
                                                      {formData?.partyno ? formData.partyno : ''}
                                                   </Text>
                                                </div>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Purchase Daybook Name
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formData?.daybookName || ''}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Purchase Account Name
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {formData?.accountName || ''}
                                                </Text>
                                             </div>
                                             <div
                                                className={`rounded-lg p-3 border-2 md:col-span-2 ${isDark ? 'bg-slate-900/50 border-slate-700' : 'bg-white border-gray-200'
                                                   }`}>
                                                <Text
                                                   className={`text-xs font-semibold mb-1 ${isDark ? 'text-gray-400' : 'text-gray-600'
                                                      }`}>
                                                   Purchase Note
                                                </Text>
                                                <Text
                                                   className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   {PurchaseNotes || storestockdata?.notes || '—'}
                                                </Text>
                                             </div>
                                          </div>
                                       </div>
                                    </GridItem>
                                 )}
                              </>
                           );
                        })()}

                     {/* Form Inputs Section */}
                     <GridItem w="100%" colSpan={1}>
                        <div className="space-y-2">
                           <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                              Transaction Date
                           </label>
                           <InputField
                              ref={transactionAtRef}
                              type="date"
                              name="transactionAt"
                              value={row[formType]?.transactionAt}
                              onChange={(e) => handleAccount(formType, 'transactionAt', e.target.value)}
                              onKeyDown={(e) => {
                                 if (
                                    (formType === 'purchaseforreceive' || formType === 'purchaseforpurchase') &&
                                    !partyNoEqalDocNo
                                 ) {
                                    handleKeyDown(e, partyNoRef);
                                 } else if (formType === 'issueforreceive' || formType === 'issueforpurchase') {
                                    handleKeyDown(e, accountRef);
                                 } else {
                                    handleKeyDown(e, daybookRef);
                                 }
                              }}
                              className={`w-full px-4 py-2.5 rounded-xl border-2 transition-all duration-200 focus:outline-none ${isDark
                                 ? 'bg-slate-900/50 border-slate-700 text-white hover:border-slate-600 focus:border-blue-500 focus:bg-slate-900 [color-scheme:dark]'
                                 : 'bg-gray-50 border-gray-200 text-gray-800 hover:border-gray-300 focus:border-blue-400 focus:bg-white'
                                 }`}
                           />
                        </div>
                     </GridItem>

                     {(formType === 'purchaseforreceive' || formType === 'purchaseforpurchase') && !partyNoEqalDocNo && (
                        <GridItem w="100%" colSpan={1}>
                           <div className="space-y-2">
                              <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 Party Doc No
                              </label>
                              <InputField
                                 ref={partyNoRef}
                                 type="text"
                                 name="partyNo"
                                 value={row[formType]?.partyNo}
                                 onChange={(e) => handleAccount(formType, 'partyNo', e.target.value)}
                                 onKeyDown={(e) => {
                                    if (formType === 'issueforreceive' || formType === 'issueforpurchase') {
                                       handleKeyDown(e, accountRef);
                                    } else {
                                       handleKeyDown(e, daybookRef);
                                    }
                                 }}
                                 className={`w-full px-4 py-2.5 rounded-xl border-2 transition-all duration-200 focus:outline-none ${isDark
                                    ? 'bg-slate-900/50 border-slate-700 text-white placeholder-gray-500 hover:border-slate-600 focus:border-blue-500 focus:bg-slate-900'
                                    : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 hover:border-gray-300 focus:border-blue-400 focus:bg-white'
                                    }`}
                              />
                           </div>
                        </GridItem>
                     )}

                     {(formType === 'issueforreceive' || formType === 'issueforpurchase') && (
                        <GridItem w="100%" colSpan={1}>
                           <div className="space-y-2">
                              <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 Account
                              </label>
                              <AccountSelect
                                 ref={accountRef}
                                 name="accountId"
                                 options={accountData}
                                 value={row[formType]?.accountId}
                                 errors={errors}
                                 errorName="header.accountId"
                                 isClearable
                                 isSearchable
                                 onChange={(value) => {
                                    handleAccount(formType, 'accountId', value);
                                 }}
                                 onKeyDown={(e) => handleKeyDown(e, daybookRef)}
                                 showCustomNoOptions={true}
                                 openfrom="salesdaybook"
                                 glGroup={{ id: 12 }}
                                 className={`rounded-xl ${isDark ? 'text-white' : 'text-gray-800'}`}
                              />
                           </div>
                        </GridItem>
                     )}

                     <GridItem w="100%" colSpan={1}>
                        <div className="space-y-2">
                           <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                              Daybook
                           </label>
                           {renderDynamicDropdown(
                              'daybookId',
                              '',
                              // daybookData.filter((item) => item.type === daybookType),
                              filteredDaybooks,
                              {
                                 errorName: 'header.daybookId',
                                 value: row[formType]?.daybookId,
                                 onChange: (value) => handleAccount(formType, 'daybookId', value),
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: daybookRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'salesdaybook',
                                 onKeyDown: (e) => {
                                    if (formType !== 'issueforreceive' && formType !== 'issueforpurchase') {
                                       if (warehouseShow) {
                                          handleKeyDown(e, warehouseRef);
                                       } else {
                                          handleKeyDown(e, itemRateRef);
                                       }
                                    } else {
                                       if (warehouseShow) {
                                          handleKeyDown(e, warehouseRef);
                                       } else {
                                          handleKeyDown(e, notesRef);
                                       }
                                    }
                                 },
                              },
                              errors,
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </div>
                     </GridItem>

                     {warehouseShow && (
                        <GridItem w="100%" colSpan={1}>
                           <div className="space-y-2">
                              <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 Warehouse
                              </label>
                              {renderDynamicDropdown(
                                 'warehouseId',
                                 '',
                                 warehouse,
                                 {
                                    errorName: 'header.warehouseId',
                                    value: row[formType]?.warehouseId,
                                    onChange: (value) => handleAccount(formType, 'warehouseId', value),
                                    focusBorderColor: 'blue.500',
                                    _focus: {
                                       boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                    },
                                    ref: warehouseRef,
                                    nextRef:
                                       formType !== 'issueforreceive' && formType !== 'issueforpurchase'
                                          ? itemRateRef
                                          : notesRef,
                                    showCustomNoOptions: true,
                                    openfrom: 'saleswarehouse',
                                    onKeyDown: (e) => {
                                       if (formType !== 'issueforreceive' && formType !== 'issueforpurchase') {
                                          handleKeyDown(e, itemRateRef);
                                       } else {
                                          handleKeyDown(e, notesRef);
                                       }
                                    },
                                 },
                                 errors,
                                 textColor,
                                 false,
                                 'Select Warehouse',
                              )}
                           </div>
                        </GridItem>
                     )}

                     {formType !== 'issueforreceive' && formType !== 'issueforpurchase' && (
                        <GridItem className="seperator-width" colSpan={1}>
                           <div className="space-y-2">
                              <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 Item Rate
                              </label>
                              {DynamicInput(
                                 'itemRate',
                                 '',
                                 {
                                    value: row[formType]?.itemRate,
                                    onChange: (e) => handleAccount(formType, 'itemRate', e.target.value),
                                    ref: itemRateRef,
                                    onKeyDown: (e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          if (paymentRefs) {
                                             paymentRefs?.current[0]?.focus();
                                          }
                                       }
                                    },
                                 },
                                 errors,
                                 textColor,
                                 'text',
                                 false,
                              )}
                           </div>
                        </GridItem>
                     )}

                     {formType !== 'issueforreceive' &&
                        formType !== 'issueforpurchase' &&
                        isOpen &&
                        paymentdata.length > 0 && (
                           <>
                              {paymentdata?.map((payment, index) => (
                                 <GridItem key={index} className="seperator-width" colSpan={1}>
                                    <div className="space-y-2">
                                       <label
                                          className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'
                                             }`}>
                                          {payment.name}
                                       </label>
                                       {DynamicInput(
                                          payment.name,
                                          '',
                                          {
                                             value: payment.amount && payment.amount !== 0 ? payment.amount : null,
                                             onChange: (e) => handlePaymentChange(payment.name, e.target.value),
                                             ref: (el) => (paymentRefs.current[index] = el),
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   if (paymentRefs.current[index + 1]) {
                                                      paymentRefs.current[index + 1].focus();
                                                   } else {
                                                      notesRef?.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </div>
                                 </GridItem>
                              ))}
                           </>
                        )}

                     <GridItem w="100%" colSpan={2}>
                        <div className="space-y-2">
                           <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                              Notes
                           </label>
                           <TextareaField
                              ref={notesRef}
                              name="notes"
                              value={row[formType]?.notes}
                              onChange={(e) => handleAccount(formType, 'notes', e.target.value)}
                              onKeyDown={(e) => {
                                 if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    if (updateRef?.current) {
                                       updateRef.current.focus();
                                    }
                                 }
                              }}
                              className={`w-full px-4 py-3 rounded-xl border-2 transition-all duration-200 focus:outline-none min-h-[100px] resize-y ${isDark
                                 ? 'bg-slate-900/50 border-slate-700 text-white placeholder-gray-500 hover:border-slate-600 focus:border-blue-500 focus:bg-slate-900'
                                 : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 hover:border-gray-300 focus:border-blue-400 focus:bg-white'
                                 }`}
                           />
                        </div>
                     </GridItem>
                  </Grid>
               )}
            </div>

            {/* Footer */}
            <div
               className={`flex items-center justify-end gap-3 px-6 py-4 rounded-b-2xl ${isDark ? 'bg-slate-900 border-t-2 border-slate-700' : 'bg-gray-50 border-t-2 border-gray-200'
                  }`}>
               <button
                  ref={cancelRef}
                  onClick={handleClose}
                  className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 ${isDark
                     ? 'text-gray-300 bg-slate-800 hover:bg-slate-700 border-2 border-slate-700 hover:border-slate-600'
                     : 'text-gray-700 bg-white hover:bg-gray-50 border-2 border-gray-300 hover:border-gray-400'
                     }`}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        updateRef.current?.focus();
                     }
                  }}>
                  Cancel
               </button>
               <button
                  ref={updateRef}
                  onClick={handleUpdate}
                  disabled={isLoading}
                  className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-2 ${isDark
                     ? 'text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-700 disabled:text-gray-400'
                     : 'text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:text-gray-500'
                     } ${isLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        cancelRef.current?.focus();
                     }
                  }}>
                  {isLoading && (
                     <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24" fill="none">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path
                           className="opacity-75"
                           fill="currentColor"
                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                     </svg>
                  )}
                  {item ? 'Save' : 'Submit'}
               </button>
            </div>
         </ModalContent>
      </Modal>
   );
};

export default IssuePurchaseEntriesModal;
